import { defineComponent as m, ref as h, reactive as f, inject as v, onMounted as p, withDirectives as _, openBlock as g, createElementBlock as y, createElementVNode as s, normalizeClass as B, renderSlot as C, createTextVNode as S, toDisplayString as k, vShow as D, unref as E } from "vue";
import w from "../../node_modules/v-wave/dist/es/index.mjs";
const N = ["aria-hidden", "aria-selected"], W = { class: "ist-tab_content" }, q = ["title"], x = { class: "ist-tab_label" }, R = /* @__PURE__ */ m({
  __name: "IstTab",
  props: {
    label: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    iconName: {
      type: String,
      default: void 0,
      required: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { vWave: b } = w.createLocalWaveDirective(), i = h({}), a = e, o = () => {
      var l, c, r, u;
      const n = ((l = i.value) == null ? void 0 : l.getBoundingClientRect().left) - (((r = (c = i.value) == null ? void 0 : c.parentElement) == null ? void 0 : r.getBoundingClientRect().left) ?? 0);
      t.id = a.id, t.left = n, t.width = (u = i.value) == null ? void 0 : u.clientWidth;
    }, d = f(v("tabsData")[a.id]), t = f(v("tabsData").selectedEvent);
    return p(() => {
      t.id == a.id && !t.width && o();
    }), (n, l) => _((g(), y("div", {
      ref_key: "tabitem",
      ref: i,
      class: "ist-tab_item",
      tabindex: "0",
      role: "tab",
      "aria-hidden": !d.isActive,
      "aria-selected": e.selected,
      onClick: o
    }, [
      s("div", W, [
        s("span", {
          class: B(["ist-tab_icon mdi " + e.iconName, "notranslate"]),
          role: "presentation",
          "aria-hidden": "true",
          title: e.label
        }, null, 10, q),
        s("div", x, [
          C(n.$slots, "default", {}, () => [
            S(k(e.label), 1)
          ], !0)
        ])
      ])
    ], 8, N)), [
      [D, d.isActive],
      [E(b)]
    ]);
  }
});
export {
  R as default
};
